export default __webpack_public_path__ + "static/media/Shannon_9781408300251.0e50e62e.jpg";